// Sticky mobile add-to-cart: show the bar only once the main ATC is scrolled out of view.
(function () {
  var bar = document.querySelector('[data-infy-sticky-atc]');
  if (!bar) return;

  var target = document.getElementById(bar.getAttribute('data-watch'));
  if (!target || !('IntersectionObserver' in window)) return;

  new IntersectionObserver(
    function (entries) {
      bar.classList.toggle('infy-sticky-atc--visible', !entries[0].isIntersecting);
    },
    { rootMargin: '0px 0px -80px 0px' }
  ).observe(target);
})();
// ponytail: price stays on product.selected_or_first_available_variant; the shared form submit
// carries the actually selected variant, so no variant-sync JS is needed here.
